export function formatUnitForecast(label) {
    if (!label)
        return null;
    if (label.endsWith('M')) {
        return label;
    }
    if (label.endsWith(',000')) {
        return `${label.replace(/,000$/, '')}K`;
    }
    return label;
}
/**
 * Formats a number as compact notation (e.g., 45000 → "45K", 1500000 → "1.5M")
 *
 * @param value - The numeric value or string to format
 * @returns Formatted string with K/M suffix, or null if invalid
 */
export function formatCompactNumber(value) {
    if (value === undefined || value === null || value === '')
        return null;
    const numericValue = typeof value === 'number'
        ? value
        : parseFloat(String(value).replace(/[^0-9.-]/g, ''));
    if (isNaN(numericValue))
        return null;
    if (numericValue >= 1_000_000) {
        const millions = numericValue / 1_000_000;
        return millions % 1 === 0 ? `${millions}M` : `${millions.toFixed(1)}M`;
    }
    if (numericValue >= 1_000) {
        const thousands = numericValue / 1_000;
        return thousands % 1 === 0 ? `${thousands}K` : `${thousands.toFixed(1)}K`;
    }
    return String(Math.round(numericValue));
}
export function formatCurrency(value) {
    if (!value)
        return null;
    const numericValue = parseFloat(value.replace(/[^0-9.]/g, ''));
    if (isNaN(numericValue)) {
        return value;
    }
    return `$${Math.round(numericValue)}`;
}
export function formatCurrencyOrHide(value) {
    if (!value)
        return null;
    const numericValue = parseFloat(value.replace(/[^0-9.]/g, ''));
    if (isNaN(numericValue) || numericValue === 0) {
        return null;
    }
    return `$${Math.round(numericValue)}`;
}
